import { render, staticRenderFns } from "./InboxConversations.vue?vue&type=template&id=be324f7a"
import script from "./InboxConversations.vue?vue&type=script&lang=ts"
export * from "./InboxConversations.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be324f7a')) {
      api.createRecord('be324f7a', component.options)
    } else {
      api.reload('be324f7a', component.options)
    }
    module.hot.accept("./InboxConversations.vue?vue&type=template&id=be324f7a", function () {
      api.rerender('be324f7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/InboxConversations.vue"
export default component.exports